import React, { useContext, useMemo, useState } from "react";
import "../css/shop.scss";
import { Link, useSearchParams } from "react-router-dom";
import productData from "../Datas/productData";
import { FiChevronDown, FiHeart, FiSliders } from "react-icons/fi";
import { CartContext } from "./CartContext";
import siteConfig from "../siteConfig";

export function ProductCard({ product }) {
  const { wishlist, toggleWishlist } = useContext(CartContext);
  const wished = wishlist.includes(product.id);

  return (
    <article className="product-card">
      <div className="product-card__image-wrap">
        <Link to={`/shopDetails/${product.id}`} onClick={() => window.scrollTo(0, 0)}>
          <img className="product-card__image primary" src={product.image} alt={product.name} loading="lazy" />
          {product.images[1] && <img className="product-card__image secondary" src={product.images[1]} alt="" loading="lazy" />}
        </Link>
        <button className={`product-card__wish ${wished ? "active" : ""}`} onClick={() => toggleWishlist(product.id)} aria-label={`${wished ? "Remove" : "Add"} ${product.name} ${wished ? "from" : "to"} wishlist`}>
          <FiHeart />
        </button>
        <span className="product-card__badge">NEW</span>
      </div>
      <div className="product-card__content">
        <p className="product-card__vendor">{product.brand}</p>
        <h3><Link to={`/shopDetails/${product.id}`} onClick={() => window.scrollTo(0, 0)}>{product.name}</Link></h3>
        <p className="product-card__price">{siteConfig.currencySymbol}{Number(product.price).toFixed(2)}</p>
      </div>
    </article>
  );
}

function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const category = searchParams.get("category") || "All";
  const search = searchParams.get("search") || "";
  const sort = searchParams.get("sort") || "featured";
  const wishlistOnly = searchParams.get("wishlist") === "true";
  const { wishlist } = useContext(CartContext);
  const categories = ["All", ...new Set(productData.map((product) => product.category))];

  const products = useMemo(() => {
    let items = productData.filter((product) => {
      const matchesCategory = category === "All" || product.category === category;
      const haystack = `${product.name} ${product.brand} ${product.category} ${product.tags.join(" ")}`.toLowerCase();
      return matchesCategory && haystack.includes(search.toLowerCase()) && (!wishlistOnly || wishlist.includes(product.id));
    });
    if (sort === "price-low") items = [...items].sort((a, b) => Number(a.price) - Number(b.price));
    if (sort === "price-high") items = [...items].sort((a, b) => Number(b.price) - Number(a.price));
    if (sort === "name") items = [...items].sort((a, b) => a.name.localeCompare(b.name));
    return items;
  }, [category, search, sort, wishlistOnly, wishlist]);

  const updateParam = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (!value || value === "All" || value === "featured") next.delete(key);
    else next.set(key, value);
    setSearchParams(next);
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="shop main">
      <section className="shop-heading">
        <p>GOOD THINGS, MADE WITH LOVE</p>
        <h1>{wishlistOnly ? "Your favorites" : category === "All" ? "New cuties" : category}</h1>
        <p className="shop-intro">Discover useful, considered essentials for your kitchen, home and workspace.</p>
      </section>
      <div className="shop-toolbar page-shell">
        <button className="filter-toggle" onClick={() => setFiltersOpen((open) => !open)}><FiSliders /> Filter <FiChevronDown /></button>
        <p>{products.length} products</p>
        <label>Sort by:
          <select value={sort} onChange={(event) => updateParam("sort", event.target.value)}>
            <option value="featured">Featured</option><option value="price-low">Price, low to high</option><option value="price-high">Price, high to low</option><option value="name">Alphabetically</option>
          </select>
        </label>
      </div>
      <div className="shop-layout page-shell">
        <aside className={`shop-filters ${filtersOpen ? "is-open" : ""}`}>
          <h2>Shop by category</h2>
          {categories.map((item) => <button key={item} className={item === category ? "active" : ""} onClick={() => updateParam("category", item)}>{item}<span>{item === "All" ? productData.length : productData.filter((p) => p.category === item).length}</span></button>)}
          {(category !== "All" || search || wishlistOnly) && <button className="clear-filters" onClick={() => setSearchParams({})}>Clear all</button>}
        </aside>
        <section className="product-grid" aria-live="polite">
          {products.length ? products.map((product) => <ProductCard product={product} key={product.id} />) : <div className="no-results"><h2>No goodies found</h2><p>Try another category or search.</p><Link to="/shop" onClick={toTop}>View everything</Link></div>}
        </section>
      </div>
    </main>
  );
}

export default Shop;
